import { ROUTE_NAMES } from '@/constant/routes'

// AHA-47221: where a PowerPoint add-in frame goes when it has no presentation to show.
//
// One function rather than the branch written out at each call site. Two of the callers race:
// PptAddinLanding's fallback timer and services/office's cold-load settle both aim a frame at
// "the presentation list", and if they ever disagreed about which list that is, a frame rescued
// by one would be yanked to the other's route by the next. The third — the editor Back inside an
// Office dialog (presentation/editor.module), where there is no history entry to step back to —
// does not race them, but a user must not be sent to one list there and another one here.
//
// All three callers now land on ROUTE_NAMES.PRESENTATIONS — the original destination — whatever
// canUsePptNewUi says. The flag still switches the rest of the new add-in UI on (the editor
// entrance, the canvas menu, the embed list's own click behaviour); it no longer decides where
// an UNRESOLVED frame is rescued to, because that rescue is a fail-safe and the dashboard list
// is the page that has always been able to serve it.
//
// EMBED_MY_PRESENTATIONS stays reachable under the flag by the one way a user asks for it
// directly — the embed user menu (EmbeddableUserMenu.goToMyPresentations) — just not from any
// of the routes above.
//
// Kept as a function, and kept as the single answer all three callers read, so restoring the
// flag branch is one edit here rather than three that can drift.
export const pptAddinListRouteName = () => ROUTE_NAMES.PRESENTATIONS

export default pptAddinListRouteName
